import { Button } from '@simplywallst/ui-core';

import type { Brokerage } from '../../hooks/useBrokerSearch';

import { getSanitisedUrl } from '../../utils';

import { StyledOl, StyledLi } from './styled';

interface Props {
  brokerage: Brokerage;
}

export const InstructionsTrading212 = ({ brokerage }: Props) => {
  const readableBrokerageUrl = getSanitisedUrl(brokerage.url);
  return (
    <StyledOl>
      <StyledLi>
        Log in to your account at{` `}
        <Button
          as="a"
          styleType="strongLink"
          href={String(brokerage.url)}
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {readableBrokerageUrl}
        </Button>
      </StyledLi>
      <StyledLi>
        Navigate to <b>Setting</b>, then select <b>API</b>
      </StyledLi>
      <StyledLi>
        Click <b>Generate API Key</b>
      </StyledLi>
      <StyledLi>Use the generated API key to log in to this flow</StyledLi>
    </StyledOl>
  );
};

export const InstructionsIBKR = ({ brokerage }: Props) => {
  const readableBrokerageUrl = getSanitisedUrl(brokerage.url);
  return (
    <StyledOl>
      <StyledLi>
        Log in to your account at{` `}
        <Button
          as="a"
          styleType="strongLink"
          href={String(brokerage.url)}
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {readableBrokerageUrl}
        </Button>
      </StyledLi>
      <StyledLi>
        Navigate to <b>Performance & Reports</b>, then select{' '}
        <b>Third-Party Reports</b>
      </StyledLi>
      <StyledLi>
        Check <b>Yodlee</b> and click <b>Save</b>
      </StyledLi>
      <StyledLi>
        Use the <b>Token</b> and <b>Query ID</b> when connecting
      </StyledLi>
    </StyledOl>
  );
};
